export const generateApolloClientHeadersForUXLCalls = (sessionId: string, operationName: string, lang?: string) => {
  return {
    headers: {
      'Accept-Language': lang ?? 'en-US',
      'x-request-id': `Phoenix-Legal-${sessionId}`,
      'Content-Type': 'application/json',
      'graphql-operation-name': operationName,
    },
  };
};
